module.exports = __webpack_public_path__ + "static/media/icita2018.b3fdffa4.PNG";